export default "__VITE_ASSET__bz8CFZFk__"